import { extend } from 'vee-validate'
import { min_value as minValue, max_value as maxValue } from 'vee-validate/dist/rules'
import { messages } from 'vee-validate/dist/locale/en.json'

extend('min_value', {
  ...minValue,
  message: messages['min_value']
})

extend('max_value', {
  ...maxValue,
  message: messages['max_value']
})
